<template>
  <v-navigation-drawer
    v-model="dataFlag"
    :clipped="$vuetify.breakpoint.lgAndUp"
    :width="500"
    fixed
    right
    @input="setFlag"
  >
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>Update Lead From</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closeDrawer" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-row align-center justify-center>
      <v-col md="12">
        <div>
          <v-card-text>
            <v-select
              :items="leads"
              v-model="currentLead"
              item-value="id"
              item-text="name"
              label="Lead From"
              filled
            ></v-select>
          </v-card-text>
        </div>
      </v-col>
    </v-row>
    <v-footer absolute height="60">
      <v-flex text-right>
        <div>
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn v-else color="primary" @click="updateLeadFrom"
            >Update Lead From</v-btn
          >
        </div>
      </v-flex>
    </v-footer>
  </v-navigation-drawer>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import companyAPI from '@/api/company.js';
import improveAPI from '@/api/superadmin.js';

export default {
  name: 'leadDrawer',
  components: {},
  props: {
    leadsDrawer: {
      type: Boolean,
      default: false,
    },
    lead_id: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      dataFlag: false,
      loading: false,
      currentLead: '',
      leads: []
    };
  },
  mounted() {
    this.getLeadsData()
  },
  methods: {
    setFlag() {
      EventBus.$emit('LEAD_DRAWER_STATE', this.dataFlag);
    },
    closeDrawer() {
      EventBus.$emit('LEAD_DRAWER_STATE', false);
    },
    updateLeadFrom() {
      this.loading = true;
      companyAPI
        .updateLeadFrom(this.$route.params.id, this.currentLead )
        .then(() => {
          this.loading = false;
          EventBus.$emit('USER_STATE_UPDATED', true); 
          this.closeDrawer();
        });
    },
    getLeadsData(){
      improveAPI.getLeadsData().then((response) => {
          this.leads = response.data.data;
        });
    },
  },
  watch: {
    leadsDrawer: {
      handler(value) {
        this.dataFlag = value;
      },
      deep: true,
    },
    lead_id:{
      handler(value) {
        this.currentLead = value;
      },
      deep: true,
    }
  },
};
</script>
<style scoped>
.v-navigation-drawer {
  min-height: 400px !important;
}
</style>
